/* PDP buy box — quantity stepper, gallery, and in-place add to cart.
 *
 * Everything here is an UPGRADE on markup that already works: the form posts to
 * /cart/add on its own and the browser lands on the cart page. If this file
 * fails to load, or the fetch fails, the page stays usable — the failure path
 * re-submits the form natively rather than leaving a dead button. */
(function () {
  var section = document.querySelector('[data-pdp]');
  if (!section) return;

  // Selected by class, not id: the id comes from the {% form %} tag's `id`
  // param, and the class is ours either way.
  var form = section.querySelector('form.pdp__form');
  var addBtn = section.querySelector('[data-pdp-add]');
  var status = section.querySelector('[data-pdp-status]');
  var qtyInput = section.querySelector('#pdp-quantity');

  var ADDED = section.getAttribute('data-added-text') || 'Added to your cart.';
  var ERROR = section.getAttribute('data-error-text') || 'Could not add that. Please try again.';

  /* ---------- quantity stepper ---------- *
   * The buttons drive the real <input>, and dispatch `change` so anything else
   * listening to the field (and Shopify's own validation) still sees it. */
  function nudge(by) {
    if (!qtyInput) return;
    var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
    var next = (parseInt(qtyInput.value, 10) || min) + by;
    qtyInput.value = String(Math.max(min, next));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  section.addEventListener('click', function (event) {
    if (event.target.closest('[data-pdp-qty-down]')) {
      event.preventDefault();
      nudge(-1);
    } else if (event.target.closest('[data-pdp-qty-up]')) {
      event.preventDefault();
      nudge(1);
    }
  });

  /* Typing straight into the field can leave it empty or below the minimum;
     normalise on blur rather than fighting the user mid-keystroke. */
  if (qtyInput) {
    qtyInput.addEventListener('blur', function () {
      var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      var value = parseInt(qtyInput.value, 10);
      if (!value || value < min) qtyInput.value = String(min);
    });
  }

  /* ---------- gallery ---------- *
   * Lives in product-gallery.js since 2026-09-03: the viewer has a phone
   * snap-track mode as well as the desktop swap, and the section loads that
   * file itself. Nothing here touches the frames. */

  /* ---------- pack selector ---------- *
   * The radios are named `id`, so selection already works with no JS at all —
   * the checked radio IS the variant posted. All this does is repaint the
   * headline price so it agrees with the selected pack.
   *
   * Prices are formatted from the shop's own money_format rather than by
   * guessing at currency symbols, so this stays correct if the store switches
   * currency. If the format cannot be parsed, the headline is simply left
   * alone — a stale-but-real price beats a confidently wrong one. */
  // Every element that shows the headline price — the readout figure and the
  // total on the button — not just the first one found.
  var priceEls = section.querySelectorAll('[data-pdp-price]');
  // Same for the crossed-out price: the headline row and the unit line can
  // both carry one, so every copy is repainted.
  var priceWasEls = section.querySelectorAll('[data-pdp-price-was]');
  /* The shop's money format. Read from the SECTION, which always renders —
   * never from a node inside an optional block. It lived on `.pdp__price`
   * until 2026-09-08, and when that row became optional every repaint below
   * silently stopped writing prices while the controls kept working.
   *
   * `getAttribute` first, and that is the whole point: `querySelector` walks
   * DESCENDANTS ONLY, so moving the attribute onto the section made the old
   * lookup return null and reproduced the exact bug the move was meant to fix.
   * The descendant lookup is kept as a fallback for any markup that still
   * carries the attribute lower down. */
  var moneyFormat =
    section.getAttribute('data-money-format') ||
    (function () {
      var el = section.querySelector('[data-money-format]');
      return el ? el.getAttribute('data-money-format') : null;
    })();

  /* ---------- the readout ---------- *
   * Jars, gummies, days: the count printed on the jar times the pack's unit
   * count, over the daily dose. All three inputs come from the section (real
   * settings, the variant title's leading integer); nothing here is typed.
   * If any input is missing the readout is left as the server rendered it. */
  var readoutEl = section.querySelector('[data-pdp-readout]');
  var unitEl = section.querySelector('[data-pdp-unit]');
  var dayEl = section.querySelector('[data-pdp-day]');
  var perJar = parseInt(section.getAttribute('data-pdp-count'), 10) || 0;
  var perDay = parseInt(section.getAttribute('data-pdp-per-day'), 10) || 0;
  var perUnitLabel = section.getAttribute('data-per-unit-label') || '';

  function fill(template, pack, gummies, days) {
    return template
      .replace(/\[pack\]/g, pack)
      .replace(/\[gummies\]/g, String(gummies))
      .replace(/\[days\]/g, String(days));
  }

  function repaintReadout(price) {
    var picked = section.querySelector('input[name="id"]:checked');
    if (!picked) return;
    var units = parseInt(picked.getAttribute('data-pack-units'), 10) || 0;
    var title = picked.getAttribute('data-pack-title') || '';

    /* Both derived figures are READ, never recomputed.
     *
     * This used to be `formatMoney(Math.round(price / units))` while the
     * section rendered the same figure with Liquid's `divided_by`, which
     * FLOORS. The two agree until a price divides awkwardly, and then the
     * server sends one number and the first pack change silently paints a
     * different one over it — on the panel where the money changes hands.
     * Liquid now derives both and hands them over on the input; this function
     * only moves strings. Do not reintroduce arithmetic here. */
    if (unitEl) {
      var perUnit = picked.getAttribute('data-pack-unit-price') || '';
      if (units > 1 && perUnit) {
        unitEl.textContent = perUnit + ' ' + perUnitLabel;
      } else {
        unitEl.textContent = unitEl.getAttribute('data-note') || '';
      }
    }

    /* The per-day rate. It hides itself rather than going stale: a pack whose
     * day count could not be derived ("Default Title", or a blank dose setting)
     * carries an empty attribute, and an empty rate must take its suffix with
     * it — a bare "a day" is worse than no line. */
    if (dayEl) {
      var rate = picked.getAttribute('data-pack-day-rate') || '';
      var dayValue = dayEl.querySelector('[data-pdp-day-value]');
      if (rate && dayValue) {
        dayValue.textContent = rate;
        dayEl.hidden = false;
      } else {
        dayEl.hidden = true;
      }
    }

    if (!readoutEl || units < 1 || perJar < 1) return;
    var gummies = perJar * units;
    var days = perDay > 0 ? Math.floor(gummies / perDay) : 0;
    var l1 = readoutEl.querySelector('[data-pdp-readout-1]');
    var l2 = readoutEl.querySelector('[data-pdp-readout-2]');
    if (l1) l1.textContent = fill(readoutEl.getAttribute('data-line1') || '', title, gummies, days);
    if (l2) l2.textContent = fill(readoutEl.getAttribute('data-line2') || '', title, gummies, days);
  }

  function formatMoney(cents) {
    var fmt = moneyFormat;
    if (!fmt) return null;
    // Shopify formats: {{amount}} 1.234,56 · {{amount_with_comma_separator}} etc.
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      var v = (cents / 100).toFixed(name.indexOf('no_decimals') > -1 ? 0 : 2);
      var parts = v.split('.');
      var whole = parts[0];
      var frac = parts[1];
      var commaSep = name.indexOf('comma_separator') > -1;
      whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, commaSep ? '.' : ',');
      return frac ? whole + (commaSep ? ',' : '.') + frac : whole;
    });
  }

  /* ---------- price, across pack AND subscription ---------- *
   * The headline price depends on TWO choices now, not one: which pack, and
   * whether it is a one-time purchase or a selling plan. The section emits a
   * variantId -> planId -> [price, compare] map (empty key = one-time), which
   * is the only place either number comes from. It is emitted whether or not
   * the product has plans, so there is one code path rather than a plans branch
   * and a no-plans branch.
   *
   * Prices are formatted from the shop's own money_format rather than by
   * guessing at currency symbols, so this stays correct if the store switches
   * currency. If anything cannot be resolved the price is left ALONE — a
   * stale-but-real price beats a confidently wrong one. */
  var priceData = null;
  var priceDataEl = section.querySelector('[data-pdp-prices]');
  if (priceDataEl) {
    try {
      priceData = JSON.parse(priceDataEl.textContent);
    } catch (e) {
      priceData = null;
    }
  }

  // Named inputs, not classes: the plan rows reuse the pack row's styling
  // classes, so a class selector would match both and pick whichever came
  // first in the DOM.
  function selectedVariantId() {
    var picked = section.querySelector('input[name="id"]:checked');
    if (picked) return picked.value;
    var hidden = form && form.querySelector('input[name="id"]');
    return hidden ? hidden.value : null;
  }

  function selectedPlanId() {
    var plan = section.querySelector('input[name="selling_plan"]:checked');
    return plan ? plan.value : '';
  }

  function priceRow() {
    var id = selectedVariantId();
    return priceData && id ? priceData[id] : null;
  }

  function repaint() {
    var row = priceRow();
    if (!row) return;

    var pair = row[selectedPlanId()] || row[''];
    if (!pair) return;

    var price = pair[0];
    var compare = pair[1] || 0;

    var formatted = formatMoney(price);
    if (formatted) {
      Array.prototype.forEach.call(priceEls, function (el) {
        el.textContent = formatted;
      });
    }
    repaintReadout(price);

    var showWas = compare > price;
    var wasText = showWas ? formatMoney(compare) : null;
    Array.prototype.forEach.call(priceWasEls, function (el) {
      if (showWas && wasText) {
        el.textContent = wasText;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });

    /* Each subscription row shows its own price for the pack now selected.
       A variant with no allocation for a plan is blanked rather than falling
       back to the one-time price, which would advertise a subscription at a
       figure Shopify will not charge. */
    var planPriceEls = section.querySelectorAll('[data-plan-price]');
    Array.prototype.forEach.call(planPriceEls, function (el) {
      var planId = el.getAttribute('data-plan-price');
      var has = Object.prototype.hasOwnProperty.call(row, planId);
      var text = has ? formatMoney(row[planId][0]) : null;
      el.textContent = text || '';
    });
  }

  /* ---------- the "buy more, save more" chip ---------- *
   * It reports whether the SELECTED pack actually saves, so the sentence is
   * only lit while it is true. The saving is read off the input, derived in
   * Liquid from the single-jar unit price — no arithmetic here, the same
   * contract as the per-jar and per-day figures above.
   *
   * Liquid renders the initial state, so this only has to maintain it: no
   * flash on load, and the chip is still correct with JavaScript off. */
  var hintEl = section.querySelector('[data-pdp-packs-hint]');
  var autoDiscEl = section.querySelector('[data-pdp-autodiscount]');

  function repaintSavingHint() {
    var picked = section.querySelector('input[name="id"]:checked');
    var saving = picked ? parseInt(picked.getAttribute('data-pack-saving'), 10) : 0;
    var saves = saving > 0;
    if (hintEl) hintEl.classList.toggle('pdp__packs-hint--live', saves);
    /* The auto-discount line is HIDDEN, not dimmed, when the pack saves nothing:
     * on the 1-jar row there is no discount at all, and a greyed-out claim is
     * still a claim. One function owns the whole "does this pack save?"
     * question so the chip and the line cannot disagree. */
    /* data-always: the section's "Always show the discount line" setting (SP_01). */
    if (autoDiscEl && !autoDiscEl.hasAttribute('data-always')) autoDiscEl.hidden = !saves;
  }

  section.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.name) return;
    if (input.name !== 'id' && input.name !== 'selling_plan') return;
    repaint();
    /* Outside repaint() on purpose: repaint() returns early when the price map
     * has no row for the selection, and the chip must still follow the pack in
     * that case. */
    repaintSavingHint();
  });

  /* ---------- add to cart ---------- */
  if (!form || !addBtn) return;

  function setStatus(message, isError) {
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('pdp__status--error', !!isError);
  }

  function setBusy(busy) {
    addBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
    addBtn.disabled = !!busy;
  }

  form.addEventListener('submit', function (event) {
    // No fetch support, or the drawer never booted: let the native post happen.
    if (typeof window.fetch !== 'function') return;

    event.preventDefault();
    setStatus('');
    setBusy(true);

    var body = new FormData(form);
    var drawer = window.ryCartDrawer;
    if (drawer && drawer.sectionId) {
      body.append('sections', drawer.sectionId);
      body.append('sections_url', window.location.pathname);
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    })
      .then(function (response) {
        return response.json().then(function (data) {
          // Shopify returns 422 with a description for real refusals — a sold
          // out variant, or more stock requested than exists. That message is
          // more useful than our generic one, so prefer it.
          if (!response.ok) throw new Error(data.description || data.message || ERROR);
          return data;
        });
      })
      .then(function (data) {
        // add.js does not report the cart total, so ask for it. Failing this
        // must not fail the add — the item IS in the cart by now.
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return { sections: data.sections, item_count: cart.item_count }; })
          .catch(function () { return { sections: data.sections }; });
      })
      .then(function (payload) {
        setStatus(ADDED, false);
        if (drawer) {
          drawer.apply(payload);
          drawer.open();
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: payload }));
      })
      .catch(function (error) {
        setStatus(error && error.message ? error.message : ERROR, true);
      })
      .finally(function () {
        setBusy(false);
      });
  });
})();
